// extracted by mini-css-extract-plugin
module.exports = {"course-card-wrapper":"course_course-card-wrapper__1ob8-"};